// @表单接口
import {
    post,
    get
} from "@/request";
const request = {
    baseUrl: CONFIG.CORE_CONFIG.URL,
    get(url, params) {
        return get(this.baseUrl + url, params)
    },
    post(url, params, options = {
        ctype: 'json'
    }) {
        return post(this.baseUrl + url, params, options)
    }
}

//行业动态
export const getPortalIndustryDynamicListApi = params => request.post('/ApiAgent/QueryAction/GetPortal_IndustryDynamicList', params)
//最新公告
export const getPortalNewestNoticeListApi = params => request.post('/ApiAgent/QueryAction/GetPortal_NewestNoticeList', params)
//成果展示
export const getPortalResultShowListApi = params => request.post('/ApiAgent/QueryAction/GetPortal_ResultShowList', params)
//行业精英
export const getIndustryEliteListApi = params => request.post('/ApiAgent/QueryAction/GetPortal_IndustryElite', params)
//行业活动（有图资讯）
export const getIndustryActivityDateListApi = params => request.post('/ApiAgent/QueryAction/GetPortal_IndustryActivityDateList', params)
//行业发展（有图资讯）
export const getIndustryDevelopListApi = params => request.post('/ApiAgent/QueryAction/GetPortal_IndustryDevelopReportList', params)
//协会动态
export const getAssociationDynamicListApi = params => request.post('/ApiAgent/QueryAction/GetPortal_AssociationDynamicList', params)
//通知公告
export const getNoticeAnnouncementListApi = params => request.post('/ApiAgent/QueryAction/GetPortal_NoticeAnnouncementList', params)

//会员动态
export const getMemberDynamicStateListApi = params => request.post('/ApiAgent/QueryAction/GetPortal_MemberDynamicState', params)
//会员名录
export const getMemberDirectorieApi = params => request.post('/ApiAgent/QueryAction/GetPortal_MemberDirectorie', params)
//人才建设--培训交流
export const getTrainExchangeListApi = params => request.post('/ApiAgent/QueryAction/GetPortal_TrainExchange', params)
//人才建设--行业精英
export const getIndustryElitePageListApi = params => request.post('/ApiAgent/QueryAction/GetPortal_IndustryElitePage', params)
//优秀成果--获奖成果
export const getAwardedResearchProductListApi = params => request.post('/ApiAgent/QueryAction/GetPortal_AwardedResearchProductList', params)
//优秀成果--成果展示
export const getResultShowApi = params => request.post('/ApiAgent/QueryAction/GetPortal_ResultShow', params)
//行业自律
export const getSelfDisciplineDocumentApi = params => request.post('/ApiAgent/QueryAction/GetPortal_SelfDisciplineDocument', params)
//政策法规
export const getPoliciesAndRegulationstApi = params => request.post('/ApiAgent/QueryAction/GetPortal_PoliciesAndRegulations', params)
//党建园地
export const getPartyGardenListApi = params => request.post('/ApiAgent/QueryAction/GetPortal_PartyGarden', params)


//快速查询
export const getPortalFastSearchListApi = params => request.post('/ApiAgent/QueryAction/GetPortal_FastSearchList', params)
//快速查询下拉框
export const getSearchScopeListApi = params => request.post('/ApiAgent/QueryAction/GetPortal_Quicklook', params)
//文档详情
export const getDocBaseInfoByIdApi = params => request.post('/ApiAgent/QueryAction/GetPortal_DocBaseInfoById', params)
//更新文档浏览次数
export const updateDocBaseInfoCntApi = params => request.post('/ApiAgent/QueryAction/GetPortal_UpdateDocReadById', params)
//行业精英详情
export const getIndustryEliteInfoByIdApi = params => request.post('/ApiAgent/QueryAction/GetPortal_IndustryEliteInfoById', params)
//关于我们
export const getDocBaseInfoByTypeApi = params => request.post('/ApiAgent/QueryAction/GetPortal_DocBaseInfoByType', params)
//查询专区
export const getSelectAreaApi = params => request.post('/ApiAgent/QueryAction/GetPortal_SelectInfo', params)
//首页-行业动态最新图片
export const getIndustryDynamicNewImageApi = params => request.post('/ApiAgent/QueryAction/GetPortal_IndustryDynamicNewImage', params)
//共通底部三个下拉框数据
export const getLinkExchangeApi = params => request.post('/ApiAgent/QueryAction/GetPortal_LinkExchange', params)
// 获取出版物信息
export const getPublicationListApi = params => request.post('/ApiAgent/QueryAction/getPublicationList', params)
// 获取最新图片
export const getPortalImageApi = params => request.post('/ApiAgent/QueryAction/GetPortal_Image', params)



